define('pubsub/brightcove',[
    'underscore',
    'jquery',
    '_pubsub'
], function(_, $, Pubsub) {
    'use strict';
    
    return function()
    {
        var oPubsub=new Pubsub;
        
        this.init=function()
        {
            this.oBrightcove=[];
            
            oPubsub.on(Pubsub.CREATE_BRIGHTCOVE_PLAYER, _.bind(this.createDeferred,this));
            oPubsub.on(Pubsub.REMOVE_BRIGHTCOVE_PLAYER, _.bind(this.removePlayer,this));
            oPubsub.on(Pubsub.PLAY_VIDEO,_.bind(this.pauseAll,this));
        };
        
        /**
         * create player deferred by requirements
         * 
         * @param {type} $el
         * @returns {undefined}
         */
        this.createDeferred=function($el)
        {
            this.requirements().done(_.bind(this.createPlayer,this,$el));
        };
        
        /**
         * resolve requirements
         * 
         * @returns {unresolved}
         */
        this.requirements=function()
        {
            var $oDeferred=new $.Deferred();
            
            if(typeof bc==='function') {
                $oDeferred.resolve();
            } else {
                require.config({
                    paths: {
                        bc: "//players.brightcove.net/2069665156001/By4xgDxvb_default/index.min"
                    }
                });
                require(['bc'], _.bind(function() {
                    $oDeferred.resolve();
                }, this));
            }
            
            return $oDeferred.promise();
        };
        
        this.createPlayer=function($el)
        {
            oPubsub.trigger(Pubsub.PLAY_VIDEO);
            
            var id=$el.attr('data-id');
            
            //create video element
            var $video=$('<video/>', {
                'id': id,
                'class': $el.attr('data-class'),
                'data-video-id': $el.attr('data-video-id'),
                'data-account': $el.attr('data-account'),
                'data-player': $el.attr('data-player'),
                'data-embed': $el.attr('data-embed'),
                'data-motionpic':$el.attr('data-motionpic'),
                'data-context':$el.attr('data-context'),
                'data-autoplay':$el.attr('data-autoplay'),
                'data-loop':$el.attr('data-loop')
            }).insertAfter($el);

            //hide/show controls
            if("true"===$el.attr('data-controls')) {
                $video.attr('controls', true);
            }

            //create instance
            bc(id);
            videojs(id).ready(_.partial(function (_this, id) {
                _this.oBrightcove.push({
                    id:id,
                    el:this
                });
                
                //set autoplay if given
                if(this.tagAttributes['data-autoplay']==="true") {
                    this.play();
                }
                
                //set loop if given
                if(this.tagAttributes['data-loop']==="true") {
                    this.on('ended', this.play);
                }
                
                this.on('play',_.partial(_this.broadcastPlay,id));
            }, this, id));
        };
        
        this.pauseAll=function(id)
        {
            _.each(this.oBrightcove,_.bind(function(item){
                if(item.id!==id) {
                    this.pause(item);
                }
            },this));
        };
        
        this.pause=function(item)
        {
            item.el.pause();
        };
        
        this.broadcastPlay=function(id)
        {
            oPubsub.trigger(Pubsub.PLAY_VIDEO,id);
        };
        
        this.removePlayer=function()
        {
            //TODO
        };
        
        this.init();
    };
});
